module.exports = __webpack_public_path__ + "img/des6.b23bb421.png";